module.exports = __webpack_public_path__ + "img/resources-1440.115ffbd7.jpg";